const ALPHABANK = {
  id: 'alfabank',
  src: {
    default: '/img/logos/partners/alfabank-default.webp',
    hover: '/img/logos/partners/alfabank-hover.webp',
  },
  href: 'https://t.me/alfadigital_jobs/?erid=2SDnjcqGvL9',
  width: 312.69,
  height: 64,
  widthMobile: 132,
  name: 'Альфа Банк',
  accent: [
    'rgba(255, 40, 11, .1)',
    'rgba(255, 173, 161, .5)'
  ]
};

const MTS = {
  id: 'mts',
  src: {
    default: '/img/logos/partners/mts-default.webp',
    hover: '/img/logos/partners/mts-hover.webp',
  },
  width: 116,
  height: 116,
  widthMobile: 54,
  href: 'https://t.me/it_is_mts/?erid=2SDnjcyri6M',
  name: 'МТС',
  accent: [
    'rgba(255, 40, 11, .08)',
    'rgba(255, 173, 161, .3)'
  ]
};

const SAMOLET = {
  id: 'samolet',
  src: {
    default: '/img/logos/partners/samolet-default.webp',
  },
  href: 'https://samolet.ru/?erid=2SDnjezo8vc',
  width: 272.45,
  height: 36,
  widthMobile: 121.09,
  name: 'Самолёт',
  accent: [
    'rgba(158, 185, 255, .12)',
    'rgba(0, 123, 251, .2)'
  ]
};

const SBER = {
  id: 'sber',
  src: {
    default: '/img/logos/partners/sber-default.webp',
    hover: '/img/logos/partners/sber-hover.webp',
  },
  width: 231,
  height: 63,
  widthMobile: 102.85,
  name: 'СБЕР',
  accent: [
    'rgba(66, 227, 180, .2)',
    'rgba(160, 231, 32, .2)'
  ],
  href: 'https://developers.sber.ru/dev/?erid=2SDnjcxDfLn',
};

const YANDER_GO = {
  id: 'yandex-go',
  src: {
    default: '/img/logos/partners/yandex-go-default.webp',
  },
  width: 280,
  href:'https://dev.go.yandex/?utm_source=southhub_websit/?erid=2SDnjeTb2kG',
  height: 80,
  widthMobile: 120,
  name: 'Яндекс GO',
  accent: [
    'rgba(255, 220, 64, .1)',
    'rgba(255, 202, 64, .4)'
  ]
};

const AVITO_TECH = {
  id: 'avito-tech',
  src: {
    default: '/img/logos/partners/avito-tech-default.webp'
  },
  href: 'https://avito.tech/we/?erid=2SDnjduFweR',
  width: 335.22,
  height: 48,
  widthMobile: 139.68,
  name: 'Avito.tech',
  accent: [
    'rgba(255, 225, 7, .16)',
    'rgba(181, 149, 255, .4)'
  ]
};

const VK = {
  id: 'vk',
  src: {
    default: '/img/logos/partners/vk-default.webp',
    hover: '/img/logos/partners/vk-hover.webp',
  },
  width: 88,
  height: 88,
  widthMobile: 38,
  href: 'https://vk.company/ru/?erid=2SDnjdpc3X6',
  name: 'VK',
  accent: [
    'rgba(111, 178, 255, .1)',
    'rgba(0, 119, 255, .25)'
  ]
};

const YANDEX_CLOUD = {
  id: 'yandex-cloud',
  src: {
    default: '/img/logos/partners/yandex-cloud-default.webp',
  },
  width: 331.16,
  height: 48,
  widthMobile: 137.98,
  name: 'Yandex Cloud',
  accent: [
    'rgba(158, 185, 255, .12)',
    'rgba(82, 139, 255, .4)'
  ]
};

const OKKO = {
  id: 'okko',
  src: {
    default: '/img/logos/delegates/okko-default.webp',
    hover: '/img/logos/delegates/okko-hover.webp',
  },
  width: 100,
  href: 'https://okko.tv/?erid=2SDnjeckb6H',
  height: 35.45,
  widthMobile: 56.01,
  name: 'Okko',
  accent: [
    'rgba(51, 0, 102, .06)',
    'rgba(210, 165, 255, .45)'
  ]
};

const USERGATE = {
  id: 'usergate',
  src: {
    default: '/img/logos/delegates/usergate-default.webp',
    hover: '/img/logos/delegates/usergate-hover.webp',
  },
  width: 175,
  height: 36.36,
  href: 'https://www.usergate.com/ru/?erid=2SDnjbqAcLZ',
  widthMobile: 123,
  name: 'UserGate',
  accent: [
    'rgba(38, 55, 79, .05)',
    'rgba(117, 190, 247, .4)'
  ]
};

const S7 = {
  id: 's7',
  src: {
    default: '/img/logos/delegates/s7-default.webp',
    hover: '/img/logos/delegates/s7-hover.webp',
  },
  width: 70,
  height: 70,
  widthMobile: 47,
  name: 'S7',
  accent: [
    'rgba(214, 246, 110, .5)',
    'rgba(172, 217, 26, .3)'
  ],
  href: 'https://www.s7.ru/ru/info/s7-airlines/brand/',
};

const TISHINA = {
  id: 'tishina',
  src: {
    default: '/img/logos/infopartners/tishina-default.webp',
  },
  width: 163.92,
  height: 58.06,
  widthMobile: 88.42,
  name: 'Тишина',
  signature: 'PR-партнёр',
  href: 'https://silencelabel.com/',
};

const CIFROVOJ_OKEAN = {
  id: 'cifrovoj-okean',
  src: {
    default: '/img/logos/infopartners/cifrovoj-okean-default.webp',
  },
  width: 152.01,
  height: 58.06,
  widthMobile: 94.13,
  name: 'Цифровой океан',
  href: 'https://digitalocean.ru/',
};

const PRODUCT_LAB = {
  id: 'product-lab',
  src: {
    default: '/img/logos/infopartners/product-lab-default.webp',
    hover: '/img/logos/infopartners/product-lab-hover.webp',
  },
  width: 179.01,
  height: 58.54,
  widthMobile: 96.55,
  name: 'Product Lab',
  accent: [
    'rgba(255, 40, 11, .08)',
    'rgba(255, 173, 161, .3)'
  ],
  href: 'https://productlab.ru/',
  signature: 'Edutainment-партнёр',
};

const COMNEWS = {
  id: 'comnews',
  src: {
    default: '/img/logos/infopartners/comnews-default.webp',
    hover: '/img/logos/infopartners/comnews-hover.webp',
  },
  width: 164,
  height: 21.41,
  widthMobile: 96,
  name: 'ComNews',
  accent: [
    'rgba(213, 65, 55, .08)',
    'rgba(255, 173, 161, .3)'
  ],
  href: 'https://www.comnews.ru/',
};

const RSPECTR = {
  id: 'rspectr',
  src: {
    default: '/img/logos/infopartners/rspectr-default.webp',
    hover: '/img/logos/infopartners/rspectr-hover.webp',
  },
  width: 80,
  height: 80,
  widthMobile: 48,
  name: 'RSpectr',
  accent: [
    'rgba(30, 112, 184, .08)',
    'rgba(108, 167, 220, .3)'
  ],
  href: 'https://rspectr.com/',
};

const ICT2GO = {
  id: 'ict2go',
  src: {
    default: '/img/logos/infopartners/ict2go-default.webp',
    hover: '/img/logos/infopartners/ict2go-hover.webp',
  },
  width: 152,
  height: 36,
  widthMobile: 81.9,
  name: 'ICT2Go',
  accent: [
    'rgba(227, 30, 36, .08)',
    'rgba(0, 160, 227, .2)'
  ],
  href: 'https://ict2go.ru/',
};

const ICTONLINE = {
  id: 'ictonline',
  src: {
    default: '/img/logos/infopartners/ictonline-default.webp',
    hover: '/img/logos/infopartners/ictonline-hover.webp',
  },
  width: 219,
  height: 42,
  widthMobile: 101.67,
  name: 'ICT Online',
  accent: [
    'rgba(227, 30, 36, .08)',
    'rgba(0, 160, 227, .2)'
  ],
  href: 'https://ict-online.ru/',
};

const IB_BANK = {
  id: 'ib-bank',
  src: {
    default: '/img/logos/infopartners/ib-bank-default.webp',
    hover: '/img/logos/infopartners/ib-bank-hover.webp',
  },
  width: 195,
  height: 65,
  widthMobile: 96,
  name: 'IB-bank',
  accent: [
    'rgba(227, 30, 36, .08)',
    'rgba(191, 24, 24, .1)'
  ],
  href: 'https://ib-bank.ru/',
};

const KOMYUTERRA = {
  id: 'komyuterra',
  src: {
    default: '/img/logos/infopartners/komyuterra-default.webp',
    hover: '/img/logos/infopartners/komyuterra-hover.webp',
  },
  width: 200,
  height: 30,
  widthMobile: 96.07,
  name: 'Компьютерра',
  accent: [
    'rgba(255, 207, 153, .3)',
    'rgba(255, 136, 0, .2)'
  ],
  href: 'https://www.computerra.ru/',
};

const CISOCLUB = {
  id: 'cisoclub',
  src: {
    default: '/img/logos/infopartners/cisoclub-default.webp',
    hover: '/img/logos/infopartners/cisoclub-hover.webp',
  },
  width: 145.72,
  height: 64,
  widthMobile: 91.07,
  name: 'CISO Club',
  accent: [
    'rgba(147, 188, 249, .3)',
    'rgba(27, 112, 240, .2)'
  ],
  href: 'https://cisoclub.ru/',
};

const CDO2DAY = {
  id: 'cdo2day',
  src: {
    default: '/img/logos/infopartners/cdo2day-default.webp',
    hover: '/img/logos/infopartners/cdo2day-hover.webp',
  },
  width: 150.77,
  height: 24,
  widthMobile: 87.95,
  name: 'CDO2DAY',
  accent: [
    'rgba(153, 165, 247, .3)',
    'rgba(55, 67, 149, .2)'
  ],
  href: 'https://cdo2day.ru/',
};

const SOVETNIK = {
  id: 'sovetnik',
  src: {
    default: '/img/logos/infopartners/sovetnik-default.webp',
    hover: '/img/logos/infopartners/sovetnik-hover.webp',
  },
  width: 166.67,
  height: 50,
  widthMobile: 93.33,
  name: 'Советник',
  accent: [
    'rgba(224, 83, 74, .2)',
    'rgba(77, 187, 115, .2)'
  ],
  href: 'https://sec-company.ru/',
};

const BANZAJ = {
  id: 'banzaj',
  src: {
    default: '/img/logos/infopartners/banzaj-default.webp',
    hover: '/img/logos/infopartners/banzaj-hover.webp',
  },
  width: 166.67,
  height: 50,
  widthMobile: 93.33,
  name: 'Банзай',
  accent: [
    'rgba(255, 186, 189, .2)',
    'rgba(237, 27, 36, .2)'
  ],
  href: 'https://nbnews.ru/',
};

const PRO = {
  id: 'pro',
  src: {
    default: '/img/logos/infopartners/pro-default.webp'
  },
  width: 112.19,
  height: 29.66,
  widthMobile: 69.14,
  name: 'Pro:',
  href: 'https://pro.rbc.ru/',
};

const INTERFAKS = {
  id: 'interfaks',
  src: {
    default: '/img/logos/infopartners/interfaks-default.webp',
    hover: '/img/logos/infopartners/interfaks-hover.webp',
  },
  width: 181.56,
  height: 56,
  widthMobile: 103.89,
  name: 'Интерфакс',
  accent: [
    'rgba(39, 155, 169, .2)',
    'rgba(126, 233, 246, .3)'
  ],
  href: 'https://www.interfax.ru/',
};

const RB = {
  id: 'rb',
  src: {
    default: '/img/logos/infopartners/rb-default.webp',
    hover: '/img/logos/infopartners/rb-hover.webp',
  },
  width: 111,
  height: 40,
  widthMobile: 66.6,
  name: 'RB.RU',
  accent: [
    'rgba(249, 126, 151, .2)',
    'rgba(173, 71, 92, .2)'
  ],
  href: 'https://rb.ru/',
};

const SILVER_RAIN = {
  id: 'silder-rain',
  src: {
    default: '/img/logos/infopartners/silder-rain-default.webp',
    hover: '/img/logos/infopartners/silder-rain-hover.webp',
  },
  width: 184,
  height: 84,
  widthMobile: 109,
  name: 'Серебряный дождь',
  accent: [
    'rgba(255, 71, 71, .2)',
    'rgba(173, 71, 92, .2)'
  ],
  href: 'https://www.silver.ru/',
};

const ECHO_MOOSE = {
  id: 'echo-moose',
  src: {
    default: '/img/logos/infopartners/echo-moose-default.webp',
    hover: '/img/logos/infopartners/echo-moose-hover.webp',
  },
  width: 177,
  height: 98.4,
  widthMobile: 105.38,
  name: 'ЭХО лОСЕЙ',
  accent: [
    'rgba(238, 114, 25, .2)',
    'rgba(236, 149, 87, .2)'
  ],
  href: 'https://ocs-radio.com/',
};

const TECHPROSVET = {
  id: 'techprosvet',
  src: {
    default: '/img/logos/infopartners/techprosvet-default.webp',
    hover: '/img/logos/infopartners/techprosvet-hover.webp',
  },
  width: 212,
  height: 63,
  widthMobile: 119,
  name: 'Техпросвет сообщество ВКонтакте',
  accent: [
    'rgba(51, 145, 253, .2)',
    'rgba(0, 119, 255, .2)'
  ],
};

export {
  ALPHABANK,
  MTS,
  SAMOLET,
  SBER,
  YANDER_GO,
  AVITO_TECH,
  VK,
  YANDEX_CLOUD,
  OKKO,
  USERGATE,
  TISHINA,
  CIFROVOJ_OKEAN,
  PRODUCT_LAB,
  COMNEWS,
  RSPECTR,
  ICT2GO,
  ICTONLINE,
  IB_BANK,
  KOMYUTERRA,
  CISOCLUB,
  CDO2DAY,
  SOVETNIK,
  BANZAJ,
  PRO,
  INTERFAKS,
  RB,
  S7,
  SILVER_RAIN,
  ECHO_MOOSE,
  TECHPROSVET
}
